
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { CreateTeamForm } from './CreateTeamForm';

interface CreateTeamModalProps {
  open: boolean;
  onClose: () => void;
}

export const CreateTeamModal = ({ open, onClose }: CreateTeamModalProps) => {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto bg-gray-800 border-gray-700 text-white">
        <DialogHeader>
          <DialogTitle className="text-sports-green text-xl">Create New Team</DialogTitle>
        </DialogHeader>
        
        <CreateTeamForm onSuccess={onClose} />
        
        <div className="flex justify-end pt-4 border-t border-gray-700">
          <Button 
            type="button" 
            variant="outline" 
            onClick={onClose} 
            className="border-gray-600 text-gray-300"
          >
            Cancel
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
